import { IBusinessService } from '../@types/services';
import {
  IFilterBusinessProps,
  BusinessDto,
} from '../../global/dataTransferObjects/business';
import { IPagedResult } from '../../global/generics';
import { ApiException } from '../../global/exceptions';
import {
  IApiResponse,
  ITecpayApi,
} from '../providers/types';
import { ISelectValue } from '../../global/types';

const businessService = (apiProvider: ITecpayApi): IBusinessService => {
  const getBusinessList = async (
    offset: number,
    pageSize: number,
    filter: IFilterBusinessProps,
  ): Promise<IApiResponse<IPagedResult<BusinessDto>>> => {
    const cnpj = filter?.cnpj || null;
    const name = filter?.name || null;
    const response = await apiProvider
      .createRequest<IPagedResult<BusinessDto>>({ url: '/payments/business' })
      .withSearch({
        offset,
        pageSize,
        cnpj,
        name,
      })
      .sendAsync();

    if (response.status !== 200) {
      throw new ApiException(response);
    }

    return response;
  };

  const getEmpresasList = async (
    offset: number,
    pageSize: number,
    filter?: IFilterBusinessProps,
  ): Promise<IApiResponse<IPagedResult<BusinessDto>>> => {
    const cnpj = filter?.cnpj || null;
    const name = filter?.name || null;
    const response = await apiProvider
      .createRequest<IPagedResult<BusinessDto>>({ url: '/payments/business' })
      .withSearch({
        offset,
        pageSize,
        cnpj,
        name,
      })
      .sendAsync();

    if (response.status !== 200) {
      throw new ApiException(response);
    }

    return response;
  };

  const mapToSelectableBusiness = (business: Array<any>): Array<ISelectValue> => business
    .map((item) => ({
      label: item.name,
      value: item.id,
    }));

  return ({
    getBusinessList,
    mapToSelectableBusiness,
    getEmpresasList,
  });
};

export default businessService;
